<fuse-widget class="widget p-0 h-100-p" fxLayout="column">
  <!-- Front -->
  <div
    class="fuse-widget-front mat-white-bg mat-elevation-z2 h-100-p"
    fxLayout="column"
    fxLayoutAlign="stretch stretch"
  >
    <div
      class="px-16 py-8 border-bottom widget-header title-bar mat-accent-bg"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div class="mat-accent-bg" fxLayout="row" fxLayoutAlign="start center">
        <div class="h3 title pr-4">{{ title }}</div>
        <div *ngIf="data?.length > 0" class="h3 secondary">({{ data?.length }})</div>
      </div>
      <app-translation-controls
        *ngIf="showTranslationControls"
        [language]="language"
        [showTranslation]="showTranslation"
        (onLanguageChange)="onLanguageChange($event)"
        (onShowTranslationChange)="onShowTranslationChange($event)"
      >
      </app-translation-controls>
    </div>

    <div class="conversation">
      <!--Note that elements in the conversation div are reversed - so we need to add items in reverse order-->

      <div *ngIf="!(readOnly || this._subject?.archived)">
        <form [formGroup]="form" fxLayout="column" fxFlex>
          <div
            class="textarea message compose"
            role="textbox"
            formControlName="message"
            contenteditable
            data-text="Type a new message"
          ></div>

          <div class="m-0 py-8" fxLayout="row" fxLayoutAlign="flex-end center">
            <div style="display: flex; gap: 4px">
              <button
                *ngIf="showAddPrivateMessage"
                id="btnAddPrivate"
                mat-raised-button
                class="save-button mat-accent"
                type="submit"
                [disabled]="!form.valid || form.pristine"
                (click)="addMessage(true)"
                aria-label="Add Private Message"
              >
                Add Private Message
              </button>
              <button
                id="btnAddPublic"
                mat-raised-button
                class="save-button mat-accent"
                type="submit"
                [disabled]="!form?.valid || form?.pristine"
                (click)="addMessage(false)"
                aria-label="Add Message"
              >
                Add Message
              </button>
            </div>
          </div>
        </form>
      </div>

      <div *ngIf="data?.length === 0" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <span class="mat-h1 hint-text pt-48">There are no messages</span>
        <span *ngIf="!(readOnly || this._subject?.archived)" class="hint-text">Type your first message below</span>
      </div>

      <div *ngIf="data?.length > 0" class="messages">
        <div
          *ngFor="let message of data"
          class="message-wrapper"
          [ngClass]="{ 'message-right': message.addedBy !== 'Complainant' }"
        >
          <div class="message" [ngClass]="{ 'message-from': message.addedBy === 'Complainant' }">
            <div class="message-header">
              <div class="message-stamp">
                <span class="message-user">
                  {{ message.userName === 'Complainant' ? referrerName : message.userName }}
                </span>
                <span>{{ message.dateTimeAdded | date : 'dd/MMM/yyyy HH:mm' }}</span>
              </div>
              <div *ngIf="message.private" class="message-private">Private</div>
            </div>
            <div>
              <span
                translate
                [language]="language"
                [showTranslation]="showTranslation"
                [innerHtml]="returnMsg(message.comment)"
              ></span>
            </div>
            <!-- referral?.referralSource && referral?.referralSource.name === 'File a Concern Website' && -->
            <div
              *ngIf="
                message.fileNames &&                
                referral?.reportJson
              "
              style="display: contents"
            >
              <hr />
              {{ message.fileNames.slice(1) }}
              <div class="message-header" style="margin-top: 2px">
                <div class="message-stamp">
                  <span>Uploaded on {{ message.dateTimeAdded | date : 'dd/MMM/yyyy' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</fuse-widget>
